import { TFunction } from 'i18next';

export const translateDynamicKey = (
  t: TFunction,
  keyPrefix: string,
  value: unknown,
): string => {
  if (typeof value !== 'string') {
    return String(value);
  }

  const key = `${keyPrefix}.${value}`;
  const translated = t(key, value);

  return translated === key ? value : translated;
};

export const translatePatientDataValue = (
  t: TFunction,
  field: 'gender' | 'chronicIllnesses',
  value: unknown,
): string => {
  switch (field) {
    case 'gender':
      return translateDynamicKey(
        t,
        'pages.studies.questions.conditions.genderValues',
        value,
      );
    case 'chronicIllnesses':
      // Use the dedicated chronicIllnesses namespace
      if (typeof value === 'string') {
        const translatedValue = t(`chronicIllnesses:${value}`, value);
        // If translation not found, it returns the key, so check and return original value
        return translatedValue === `chronicIllnesses:${value}`
          ? value
          : translatedValue;
      }
      return String(value);
    default:
      return String(value);
  }
};
